module.exports = __webpack_public_path__ + "media/pencils/pencil-blue-filled-1cb6e180.svg";